export default __webpack_public_path__ + "static/media/K2500Gallery5.eec9a82a.jpg";